import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import cn from 'classnames';
import { connect } from 'react-redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';

import styles from './ErknmReasonProgramDocument.module.scss';
import { getTitleFieldWithRedStar } from '../../../functions/getTitleFieldWithRedStar';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { getKnmSystemType } from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { KnmSystemTypesEnum } from '../../../KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import { getDecisionFormRef } from '../../../DecisionPackage/MainModule/selectors/decisionSelectors';

interface IErknmReasonProgramDocumentProps {
  watchOnly: boolean;
  name: string;
  programAttachment: IKnmAttachment[] | null | undefined;
  formRef?: IKnmFormRef;
}

interface IErknmReasonProgramDocumentStoreProps {
  isPm: boolean;
  isKnm: boolean;
  isDecision: boolean;
}

const ErknmReasonProgramDocumentWithoutStore = memo(
  ({
    watchOnly,
    name,
    programAttachment,
    formRef,
    isKnm,
    isDecision,
    isPm,
  }: IErknmReasonProgramDocumentProps & IErknmReasonProgramDocumentStoreProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={styles.ActDocument}>
        <div className="shared-group-label">
          {getTitleFieldWithRedStar({
            label: 'Файл программы проверок',
            field: name,
            isPm,
            isDecision,
            isKnm,
          })}
          <span className="shared-no-wrap-text">
            <Button
              className={cn('shared-btn-add', styles.ActDocumentAddButton)}
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={watchOnly || (!!programAttachment && programAttachment.length > 0)}
              onClick={openSignModal}
            />
          </span>
        </div>

        <KnmAttachmentsSigning
          acceptedFiles=".pdf,.png,.jpeg,.ktd,.rtf,.rar,.zip"
          isWatchOnly={watchOnly}
          name={name}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const fieldError =
              props.errors?.reasonsErknm?.[0]?.programAttachment || props.errors?.reasonsPm?.[0]?.programAttachment;
            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (errorMessage) {
              return <p className="shared-input-error shared-row__small-margin">{errorMessage}</p>;
            }

            return null;
          }}
        </FormSpy>
      </div>
    );
  },
);

const mapStateToProps = (state: IRootState): IErknmReasonProgramDocumentStoreProps => ({
  isPm: getKnmSystemType(state) === KnmSystemTypesEnum.PM,
  isKnm: getKnmSystemType(state) === KnmSystemTypesEnum.ERKNM,
  isDecision: !!getDecisionFormRef(state),
});

export const ErknmReasonProgramDocument = connect(mapStateToProps)(ErknmReasonProgramDocumentWithoutStore);
